var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenFileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38131 14.1382C2.9615 14.1382 2.60376 13.9904 2.30811 13.6947C2.01245 13.3991 1.86462 13.0413 1.86462 12.6215V3.38387C1.86462 2.96406 2.01245 2.60633 2.30811 2.31067C2.60376 2.01502 2.9615 1.86719 3.38131 1.86719H8.00014V3.38387H3.38131V12.6215H12.619V8.0027H14.1357V12.6215C14.1357 13.0413 13.9878 13.3991 13.6922 13.6947C13.3965 13.9904 13.0388 14.1382 12.619 14.1382H3.38131ZM6.59036 10.4694L5.53347 9.41249L11.5621 3.38387H9.33347V1.86719H14.1357V6.66937H12.619V4.44075L6.59036 10.4694Z",
    fill: "#2C2D2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFileIcon);
export default __webpack_public_path__ + "static/media/OpenFileIcon.4e8fb97c918789ca1ead9bf251552122.svg";
export { ForwardRef as ReactComponent };